import { AvailableServices } from 'Integrations/domain'
import { INTEGRATIONS_CONFIG } from 'Integrations/integrationsConfig/integrations.config'

export const getIntegrationName = (service: AvailableServices): string => {
  return INTEGRATIONS_CONFIG[service]?.title ?? service
}
